import { extractArrayFromQuery, mapAttributes } from '../../../utils/query';

import audience from './audience';

const attributes = {
  audience
};

export const attributeKeys = _.keys(attributes);

export default mapAttributes(attributes);
